import AccessTimeOutlinedIcon from '@mui/icons-material/AccessTimeOutlined';
import BarChartIcon from '@mui/icons-material/BarChart';
import BusinessCenterIcon from '@mui/icons-material/BusinessCenter';
import FmdGoodOutlinedIcon from '@mui/icons-material/FmdGoodOutlined';
import MenuBookOutlinedIcon from '@mui/icons-material/MenuBookOutlined';
import MonetizationOnOutlinedIcon from '@mui/icons-material/MonetizationOnOutlined';
import { Box, Card, Grid } from '@mui/material';
import { IJob } from 'wisestep-api';
import { WsTypography, WsTypoVariants, WsTypoColors, WsIconText, WsColors } from 'wisestep-base';

export interface JobDetailsCardProps {
  jobsData: IJob;
}
const JobDetailsCard = ({ jobsData }: JobDetailsCardProps) => {
  const cityAndCountry = jobsData.locations?.map((place) => {
    return place.city + ',' + place.country;
  });
  const compensation =
    jobsData.salaryCurrency && jobsData.minimumSalary
      ? jobsData.salaryCurrency + ' ' + jobsData.minimumSalary + ' - ' + jobsData.maximumSalary
      : jobsData.salaryAlternateDisplayText;
  return (
    <Card sx={{ borderBottom: '1px solid #00B4D8' }}>
      <Grid container bgcolor={WsColors.TheBlues50} spacing={2} p={4}>
        <Grid container item xs={12}>
          {jobsData.title && (
            <Grid container item xs={6}>
              <Box pt={0.5} pr={0.5}>
                <BusinessCenterIcon color="info" />
              </Box>
              <Box>
                <WsTypography
                  variant={WsTypoVariants.TITLE}
                  color={WsTypoColors.SENARY}
                  display="inline"
                >
                  {jobsData.title}
                </WsTypography>
              </Box>
            </Grid>
          )}
          {jobsData.jobCode && (
            <Grid container item xs={4}>
              <Box>
                <WsTypography
                  variant={WsTypoVariants.SUB_TITLE}
                  color={WsTypoColors.TERTIARY}
                  display="inline"
                >
                  {jobsData.jobCode}
                </WsTypography>
              </Box>
              <Box pt={0.5} pl={0.5}>
                <BarChartIcon color="action" />
              </Box>
            </Grid>
          )}
        </Grid>

        <Grid container item xs={12}>
          {cityAndCountry && (
            <Grid item xs={3}>
              <WsIconText
                icon={<FmdGoodOutlinedIcon color="action" />}
                text={cityAndCountry[0]}
                opacity={true}
              />
            </Grid>
          )}
          {compensation && (
            <Grid item xs={3}>
              <WsIconText
                icon={<MonetizationOnOutlinedIcon color="action" />}
                text={compensation}
                opacity={true}
              />
            </Grid>
          )}
          {jobsData.workAuthorization && (
            <Grid item xs={3}>
              <WsIconText
                icon={<AccessTimeOutlinedIcon color="action" />}
                text={jobsData.workAuthorization}
                opacity={true}
              />
            </Grid>
          )}
          {jobsData.visaRequirements && (
            <Grid item xs={3}>
              <WsIconText
                icon={<MenuBookOutlinedIcon color="action" />}
                text={jobsData.visaRequirements}
                opacity={true}
              />
            </Grid>
          )}
        </Grid>
      </Grid>
    </Card>
  );
};

export default JobDetailsCard;
